export default "__VITE_ASSET__Dt1CWxj3__"